module.exports = __webpack_public_path__ + "img/10.32a4debf.jpg";